import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = ["aria-expanded"]
const _hoisted_2 = { class: "space-y-2" }
const _hoisted_3 = {
  key: 0,
  class: "font-primary text-h3-sm md:text-h3-md lg:text-h3-lg text-black transition-colors duration-200 group-hover:text-orange-500"
}
const _hoisted_4 = {
  key: 1,
  class: "text-concrete-700"
}
const _hoisted_5 = { class: "overflow-hidden" }
const _hoisted_6 = { class: "pb-1" }
const _hoisted_7 = {
  key: 0,
  class: "mb-5 text-concrete-700"
}

import { ref } from "vue";

import Prose from "~/vue/atoms/texts/TextProse.vue";
import GridFaq from "~/vue/organisms/grids/GridFaq.vue";

interface FaqItem {
	id: string | number;
	question: string;
	answer: string;
}

interface Props {
	heading?: string | null;
	description?: string | null;
	items: FaqItem[];
	animate?: boolean;
}


export default /*@__PURE__*/_defineComponent({
  __name: 'GroupFaq',
  props: {
    heading: { default: null },
    description: { default: null },
    items: {},
    animate: { type: Boolean, default: false }
  },
  setup(__props: any) {

const props = __props;

const isExpanded = ref(false);

const toggle = () => {
	isExpanded.value = !isExpanded.value;
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(__props.animate ? 'animate-fade-in-up' : '')
  }, [
    _createElementVNode("button", {
      type: "button",
      class: "group mb-6 flex w-full cursor-pointer items-start justify-between gap-6 text-left focus:outline-none focus:ring-2 focus:ring-celestial-500",
      "aria-expanded": isExpanded.value,
      onClick: toggle
    }, [
      _createElementVNode("div", _hoisted_2, [
        (__props.heading)
          ? (_openBlock(), _createElementBlock("h3", _hoisted_3, _toDisplayString(__props.heading), 1))
          : _createCommentVNode("", true),
        (__props.description && !isExpanded.value)
          ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
              _createVNode(Prose, { html: __props.description }, null, 8, ["html"])
            ]))
          : _createCommentVNode("", true)
      ]),
      _createElementVNode("span", {
        class: _normalizeClass(["mt-2 ml-4 shrink-0 transform text-viridian-500 transition-transform duration-300", isExpanded.value ? 'rotate-180' : 'rotate-0'])
      }, [...(_cache[0] || (_cache[0] = [
        _createElementVNode("svg", {
          xmlns: "http://www.w3.org/2000/svg",
          width: "16",
          height: "16",
          fill: "currentColor",
          viewBox: "0 0 16 16"
        }, [
          _createElementVNode("path", {
            "fill-rule": "evenodd",
            d: "M1.646 4.646a.5.5 0 0 1 .708 0L8 10.293l5.646-5.647a.5.5 0 0 1 .708.708l-6 6a.5.5 0 0 1-.708 0l-6-6a.5.5 0 0 1 0-.708z"
          })
        ], -1)
      ]))], 2)
    ], 8, _hoisted_1),
    _createElementVNode("div", {
      class: _normalizeClass(["grid transition-all duration-300 ease-in-out", isExpanded.value ? 'grid-rows-[1fr] opacity-100' : 'grid-rows-[0fr] opacity-0'])
    }, [
      _createElementVNode("div", _hoisted_5, [
        _createElementVNode("div", _hoisted_6, [
          (__props.description)
            ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
                _createVNode(Prose, { html: __props.description }, null, 8, ["html"])
              ]))
            : _createCommentVNode("", true),
          _createVNode(GridFaq, {
            items: __props.items,
            animate: __props.animate
          }, null, 8, ["items", "animate"])
        ])
      ])
    ], 2)
  ], 2))
}
}

})